import React, { useReducer, useEffect } from "react"
import classNames from "classnames"
import JobTitleAutocomplete from "./wrappers/JobTitleAutocomplete"
import LocationAutocomplete from "./wrappers/LocationAutocomplete"
import SkillAutocomplete from "./wrappers/SkillAutocomplete"
import RoleTypeDropdown from "./wrappers/RoleTypeDropdown"
import ActivityTypeDropdown from "./wrappers/ActivityTypeDropdown"
import GenderTypeDropdown from "./wrappers/GenderTypeDropdown"
import RaceTypeDropdown from "./wrappers/RaceTypeDropdown"
import ProfessionDropdown from "./wrappers/ProfessionDropdown"
import ExperienceLevelDropdown from "./wrappers/ExperienceDropdown"
import IndustryDropdown from "./wrappers/IndustryDropdown"
import CompanyNameInput from "./wrappers/CompanyNameInput"
import TitleInput from "./wrappers/TitleInput"
import CompanyRoleTypeDropdown from "./wrappers/CompanyRoleTypeDropdown"
import CompanyActivityTypeDropdown from "./wrappers/CompanyActivityTypeDropdown"
import CompanyIndustryTypeDropdown from "./wrappers/CompanyIndustryTypeDropdown"
import CompanyDiverseTypeDropdown from "./wrappers/CompanyDiverseTypeDropdown"
import CompanyClassificationMultiSelectDropdown from "./wrappers/CompanyClassificationMultiSelectDropdown"
import CompanyMarketTypeDropdown from "./wrappers/CompanyMarketTypeDropdown"
import CompanyCertifiedTypeDropdown from "./wrappers/CompanyCertifiedTypeDropdown"
import CompanyVerificationTypeDropdown from "./wrappers/CompanyVerificationTypeDropdown"
import CompanyTypeDropdown from "./wrappers/CompanyTypeDropdown"
import LevelTypeDropdown from "./wrappers/LevelTypeDropdown"
import CategoryTypeDropdown from "./wrappers/CategoryTypeDropdown"
import FreelancersCountryDropdown from "./wrappers/FreelancersCountryDropdown"
import RadioButton from "../../RadioButton/RadioButton"
import Button from "../../Button/Button"
import { ReactComponent as ArrowTopIcon } from "../../../images/icons/arrow-top.svg"
import { reducer, initState } from "./useReducer/reducer"
import {
  toggleCollapse,
  openIndividualSubForm,
  openCompanySubForm,
  setWholeState,
  resetForm,
  openFreelancersSubForm,
} from "./useReducer/actionCreators"
import styles from "./index.module.scss"
import { jobTitleOptions } from "../../CompanyUserInfo/options/jobTitleOptions"
import features from "../../../features"
import { getAppliedFilterKey } from "./filterSyncKey"

const MemberSearchFilter = ({
  classes,
  requestResultGroup,
  onReset,
  onSubmit,
}) => {
  const [state, dispatch] = useReducer(reducer, initState)
  const appliedFilterKey = getAppliedFilterKey(requestResultGroup)

  useEffect(() => {
    dispatch(setWholeState(requestResultGroup))
  }, [appliedFilterKey, requestResultGroup])
  return (
    <>
      <div
        className={classNames(styles.filter, classes, {
          [styles.isCollapse]: state.isCollapse,
        })}
      >
        <div
          className={styles.header}
          onClick={() => dispatch(toggleCollapse())}
        >
          <p className={styles.caption}>All Filters</p>
          <div className={styles.collapseIcon}>
            <ArrowTopIcon />
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.body}>
            <div className={styles.block}>
              <RadioButton
                className={styles.radioBtn}
                label="Companies/Organizations"
                checked={state.values.accountType === "company"}
                onClick={() => dispatch(openCompanySubForm())}
              />
              <div
                className={classNames(styles.subForm, {
                  [styles.opened]: state.values.accountType === "company",
                })}
              >
                <div className={styles.item}>
                  <CompanyTypeDropdown
                    selectedType={state.values.companyType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <CompanyRoleTypeDropdown
                    selectedType={state.values.companyRoleType}
                    externalDispatch={dispatch}
                  />
                </div>
                {state.values.companyRoleType === "financial_organizations" && (
                  <div className={styles.item}>
                    <CompanyActivityTypeDropdown
                      selectedType={state.values.companyActivityType}
                      externalDispatch={dispatch}
                    />
                  </div>
                )}
                <div className={styles.item}>
                  <CompanyIndustryTypeDropdown
                    selectedType={state.values.companyIndustryType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <LevelTypeDropdown
                    selectedType={state.values.levelType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <CompanyDiverseTypeDropdown
                    selectedType={state.values.companyDiverseType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <CompanyVerificationTypeDropdown
                    selectedType={state.values.companyVerificationType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <CompanyCertifiedTypeDropdown
                    selectedType={state.values.companyCertified}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <CompanyClassificationMultiSelectDropdown
                    selectedType={state.values.companyClassification}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <CompanyMarketTypeDropdown
                    selectedType={state.values.companyMarket}
                    externalDispatch={dispatch}
                  />
                </div>
              </div>
            </div>

            <div className={styles.block}>
              <RadioButton
                className={styles.radioBtn}
                label="Professionals"
                checked={state.values.accountType === "individual"}
                onClick={() => dispatch(openIndividualSubForm())}
              />
              <div
                className={classNames(styles.subForm, {
                  [styles.opened]: state.values.accountType === "individual",
                })}
              >
                <div className={styles.item}>
                  <CompanyNameInput
                    companyNameInput={state.values.companyNameInput}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <TitleInput
                    titleInput={state.values.titleInput}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <ProfessionDropdown
                    selectedType={state.values.professionType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <IndustryDropdown
                    selectedType={state.values.companyIndustryType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <ExperienceLevelDropdown
                    selectedType={state.values.experienceType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <GenderTypeDropdown
                    selectedType={state.values.genderType}
                    externalDispatch={dispatch}
                  />
                </div>
                <div className={styles.item}>
                  <CompanyMarketTypeDropdown
                    selectedType={state.values.companyMarket}
                    externalDispatch={dispatch}
                  />
                </div>
              </div>
            </div>

            {features.upworkIntegration && (
              <div className={styles.block}>
                <RadioButton
                  className={styles.radioBtn}
                  label="Freelancers"
                  checked={state.values.accountType === "freelancers"}
                  onClick={() => dispatch(openFreelancersSubForm())}
                />
                <div
                  className={classNames(styles.subForm, {
                    [styles.opened]: state.values.accountType === "freelancers",
                  })}
                >
                  <div className={styles.item}>
                    <CategoryTypeDropdown
                      selectedType={state.values.categoryType}
                      externalDispatch={dispatch}
                    />
                  </div>
                  <div className={styles.item}>
                    <FreelancersCountryDropdown
                      selectedType={state.values.freelancersCountry}
                      externalDispatch={dispatch}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={styles.footer}>
            <Button
              buttonStyle="outlined"
              className={styles.btn}
              onClick={() => {
                dispatch(resetForm())
                onReset()
              }}
            >
              Clear
            </Button>
            <Button
              className={styles.btn}
              onClick={() => onSubmit(state.values)}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
      {features.upworkIntegration &&
        state.values.accountType === "freelancers" && (
          <div className={styles.contactWrapper}>
            <Button
              width="100%"
              component="a"
              href="mailto:ambassador@theb2t.com"
            >
              Contact Account Executive
            </Button>
          </div>
        )}
    </>
  )
}
export default MemberSearchFilter
